// Helpers for the JWT "token" cookie shared between the BO frontend
// and the backend API. The cookie has to be valid across subdomains
// (bo-stg.madamefin.com ↔ api-stg.madamefin.com) so plain <img src>
// tags pointing at /files/... reach the backend with auth — the
// browser only sends Authorization headers via XHR, never on <img>.

// authCookieDomain returns the parent domain to scope the cookie to,
// so it travels between subdomains. Returns null for localhost / IP
// addresses so the cookie defaults to the current host during dev.
export function authCookieDomain() {
    const host = (typeof window !== "undefined" && window.location && window.location.hostname) || "";
    if (!host || host === "localhost" || /^[\d.]+$/.test(host)) {
        return null;
    }
    const parts = host.split(".");
    if (parts.length < 2) return null;
    return "." + parts.slice(-2).join(".");
}

// setAuthCookie writes the token with the right domain + 1-day expiry.
export function setAuthCookie(VueCookie, token) {
    const opts = { expires: "1D" };
    const dom = authCookieDomain();
    if (dom) opts.domain = dom;
    VueCookie.set("token", token, opts);
}

// deleteAuthCookie clears the token. Cookies are bound to (name, domain,
// path) — deleting without specifying the domain on a cross-subdomain
// cookie leaves the parent-domain entry intact, so the user appears
// logged out in the current tab but the backend still accepts the
// stale token from /files/... requests.
export function deleteAuthCookie(VueCookie) {
    const dom = authCookieDomain();
    if (dom) {
        VueCookie.delete("token", { domain: dom });
    }
    // Always clear the host-scoped entry too in case an older session
    // wrote one without the domain attribute.
    VueCookie.delete("token");
}
